/**
 * 🧚 PIXIE AVATAR - Avatar réutilisable de Pixie
 * Remplace l'emoji 🧚‍♀️ par le vrai visage de Pixie
 */

import React from 'react';

const PIXIE_IMAGE_URL = '/pixie-face.png';

export const PixieAvatar = ({ 
  size = 'md', 
  className = '',
  withGlow = false,
  withBorder = true 
}) => {
  const sizeClasses = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-14 h-14',
    xl: 'w-20 h-20',
    '2xl': 'w-24 h-24'
  };

  return (
    <div 
      className={`
        ${sizeClasses[size] || sizeClasses.md}
        rounded-full overflow-hidden flex-shrink-0
        ${withBorder ? 'ring-2 ring-pink-500/50' : ''}
        ${withGlow ? 'shadow-lg shadow-pink-500/30' : ''}
        ${className}
      `}
    >
      <img 
        src={PIXIE_IMAGE_URL} 
        alt="Pixie" 
        className="w-full h-full object-cover"
        loading="lazy"
      />
    </div>
  );
};

// Version inline pour remplacer les émojis dans le texte
export const PixieInline = ({ size = 'sm' }) => {
  const sizeClasses = {
    xs: 'w-4 h-4',
    sm: 'w-5 h-5',
    md: 'w-6 h-6',
    lg: 'w-8 h-8'
  };

  return (
    <img 
      src={PIXIE_IMAGE_URL} 
      alt="Pixie" 
      className={`${sizeClasses[size]} inline-block rounded-full object-cover align-middle`}
      loading="lazy"
    />
  );
};

export default PixieAvatar;
